import { createReducer } from '@reduxjs/toolkit'
import { get, setWith } from 'lodash-es'
import Status from '@constants/request_statuses.ts'
import GlobalActionTypes from '@constants/action_types.js'
import { loadShareable } from '../actions.js'

const initialState = {
  fetchings: {
    // contains status/error for each resource type
    // Timeline: { 1: { state, error } }
  },
  // timeline: { 1: { ...data... } }
}

export const reducer = createReducer(initialState, builder => {
  builder
    .addCase(GlobalActionTypes.RECEIVE_ENTITIES, (state, action) => receiveEntities(state, action))
    .addCase(loadShareable.pending, (state, action) => {
      const { shareableType, shareableId } = action.meta.arg
      const value = {
        status: Status.LOADING,
        error: null,
      }
      setWith(state.fetchings, [shareableType, shareableId], value, Object)
    })
    .addCase(loadShareable.fulfilled, (state, action) => {
      const { shareableType, shareableId } = action.meta.arg
      const value = {
        status: Status.SUCCEEDED,
        error: null,
      }
      setWith(state.fetchings, [shareableType, shareableId], value, Object)
    })
    .addCase(loadShareable.rejected, (state, action) => {
      const { shareableType, shareableId } = action.meta.arg
      const value = {
        status: Status.FAILED,
        error: null,
      }
      setWith(state.fetchings, [shareableType, shareableId], value, Object)
    })
})

const receiveEntities = (state, action) => {
  const { payload } = action
  if (payload.hasOwnProperty('shareable')) {
    const shareable = payload.shareable
    const shareableType = shareable.type
    const shareableId = shareable.id
    setWith(state, [shareableType, shareableId], shareable, Object)
  }
  return state
}

export default reducer

// SELECTORS

const selectBase = state => state.sharing

export const selectShareable = (state, props) => {
  const { shareableType, shareableId } = props
  return get(selectBase(state), [shareableType, shareableId]) // Note: Could be null
}

export const selectShareableStatus = (state, props) => {
  const base = selectBase(state)
  return get(base.fetchings, [props.shareableType, props.shareableId, 'status']) || Status.IDLE
}

export const selectShareableError = (state, props) => {
  const base = selectBase(state)
  return get(base.fetchings, [props.shareableType, props.shareableId, 'error'])
}
